// extracted by mini-css-extract-plugin
export var colorSquare = "_pe-0";
export var danger = "_pe-5";
export var lightPink = "_pe-8";
export var neutralBlue = "_pe-7";
export var neutralYellow = "_pe-6";
export var normal = "_pe-1";
export var primary = "_pe-2";
export var primaryLight = "_pe-3";
export var solidBlack = "_pe-g";
export var solidGreen = "_pe-b";
export var solidLightBlue = "_pe-d";
export var solidNavy = "_pe-c";
export var solidOrange = "_pe-f";
export var solidPink = "_pe-e";
export var solidRed = "_pe-9";
export var solidYellow = "_pe-a";
export var success = "_pe-4";